import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import IconButton from '@mui/material/IconButton'
import { euiIconTypeMap } from 'components/icons'
import { GoodProduct } from '../../../../graphql'

const EditIcon = euiIconTypeMap.pencil

export default function getActions(
	canEdit: boolean,
	openEditModal: ( part: GoodProduct ) => void,
): GridColDef {
	return {
		field: 'actions',
		hideable: false,
		headerName: 'Actions',
		width: 100,
		sortable: false,
		filterable: false,
		renderCell: ( params: GridRenderCellParams ) => {
			if ( !canEdit ) return null
			return (
				<IconButton color="primary" aria-label="Edit product" onClick={() => openEditModal( params.row as GoodProduct )}>
					<EditIcon />
				</IconButton>
			)
		},
	}
}
